<app-navbar [title]="'Sezon'">
	<button class="btn btn-primary me-2" (click)="submit()"><i class="fas fa-sign-out-alt"></i> Raport</button>
	<button class="btn btn-primary me-2" (click)="reportCancel()">
		<i class="fas fa-sign-out-alt"></i> Raport Anulowanych
	</button>
	<button class="btn btn-primary me-2" (click)="setToMap('departure')" *ngIf="showCheckboxes">
		<i class="fas fa-sign-out-alt"></i> Logistyka - Wyjazd
	</button>
	<button class="btn btn-primary me-2" (click)="setToMap('return')" *ngIf="showCheckboxes">
		<i class="fas fa-sign-in-alt"></i> Logistyka - Powrót
	</button>
	<button class="btn btn-primary me-2" (click)="showCheckboxes = !showCheckboxes" *ngIf="!showCheckboxes">
		<i class="fas fa-map-marked-alt"></i> Logistyka
	</button>
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<div class="modal" id="deleteModal" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-body">
				<h2>Czy wiesz, że?</h2>
				<h5>Usuwając już nigdy nie zostanie przywrócona pozycja w sezonie ? X D</h5>
				Dlatego rozwiąż zadanie ile jest 9*9= <br />

				<input
					type="number"
					[(ngModel)]="checksum"
					class="form-control"
					name="checksum"
					id="checksum"
					min="0"
				/>
				<br />
				<button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="deleteSeason(checksum)">
					USUŃ
				</button>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="deleteClose()">
					Wyjdź
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal" id="raportModal" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-body">
				<a href="https://docs.google.com/spreadsheets/d/197x3OR42yYfmKnFzjBvFG6GpqgP_NIy_Tr_niDJiqyk/edit"
					>DOKUMENT DANE POJAWIĄ SIĘ ZA 5 OKOŁO 5 MINUT</a
				>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="raportClose()">
					Wyjdź
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal" id="raportModalReportCancel" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-body">
				<a
					href="https://docs.google.com/spreadsheets/d/143Bqdf9AOoEn6inNKgG4i8L0-q1IR3ikM8U3p_JHEdI/edit#gid=222288510"
					>Pliczynio</a
				><br />
				Pamiętaj o przeciągnieciu Formułki z Komóreczki I1
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="raportClose()">
					Wyjdź
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal" id="settingsModal" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered-lg">
		<div class="modal-content">
			<div class="modal-body">
				<h5>Status</h5>
				<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
					<span *ngFor="let status of statuses">
						<input
							type="radio"
							class="btn-check"
							name="status"
							id="status{{ status.id }}"
							autocomplete="off"
							value="{{ status.id }}"
							[(ngModel)]="settingsObject.status"
						/>
						<label class="btn btn-outline-primary me-2" for="status{{ status.id }}">
							{{ status.name }}
						</label>
					</span>
				</div>
			</div>
			<div class="modal-body">
				<h5>Wydarzenia</h5>

				<div *ngFor="let item of settingsObject.tourismEvents">
					<a href="tourism-events/{{ item.tourismEventsId }}">
						{{ item.vehiclesName }}
						({{ item.vehiclesSeats }} +2)
						{{ item.tourismEventStatus }}
						{{ item.tourismEventsName }} - {{ item.kind }}</a
					>
				</div>
				<br />
				<h6>Id Sezonu {{ settingsObject.id }}</h6>
			</div>
			<div class="modal-body">
				<a href="offers/{{ settingsObject.offerId }}">
					<h4>Oferta</h4>
				</a>
				<h5>
					Przychody: {{ settingsObject.income }}<br />
					Koszty: {{ settingsObject.costs }}<br />
					Zysk: {{ settingsObject.profit }}<br />
					Panowane płatności: {{ settingsObject.plannedPayments }}<br />
					Koszt stały: {{ settingsObject.costsFixed }}<br />
					Koszty zmienny : {{ settingsObject.costsVariable }}<br />
				</h5>
				Id oferty: {{ settingsObject.offerId }} Id terminy:
				{{ settingsObject.offerTermId }}
			</div>

			<div class="modal-body">
				<h4>Sprzedaż</h4>
				<h5>
					<!-- Aktualna cena: 1499 pln <br /> -->
					Ostatni tydzień : {{ settingsObject.sell7days }} os śr.cena: {{ settingsObject.price7days }}<br />
					2 Tygodnie temu: {{ settingsObject.sell14days }} os śr.cena: {{ settingsObject.price14days }} <br />
					3 Tygodnie temu: {{ settingsObject.sell21days }} os śr.cena: {{ settingsObject.price21days }}<br />
					Więcej niż 3 Tygodnie temu:
					{{ settingsObject.sellmore21days }} os śr.cena:
					{{ settingsObject.pricemore21days }}
				</h5>
			</div>

			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="settingsSave()">Zapisz</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="settingsClose()">
					Wyjdź
				</button>
				<button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="delete()">Błąd</button>
			</div>
		</div>
	</div>
</div>

<app-season-filters
	[userFilters]="'season'"
	[statuses]="statuses"
	[users]="users"
	[kinds]="kinds"
	(selected)="filtersSelected($event)"
></app-season-filters>

<div class="filter-box">
	<div class="row">
		<div class="col-sm-10">
			<input
				type="text"
				class="form-control w-100"
				(keyup)="refreshFilter()"
				[(ngModel)]="filterValue"
				placeholder="Filtrowanie"
			/>
		</div>
		<div class="col-sm-2 text-center">
			<button class="btn btn-secondary me-2" (click)="filtersOpen()">
				<i class="fas fa-filter"></i>
			</button>
		</div>
	</div>
</div>

<table class="table table-striped table-hover table-bordered table-sm">
	<thead>
		<tr>
			<th *ngIf="showCheckboxes"></th>
			<th>Nazwa</th>
			<th>Wyjazd z Polski</th>
			<!-- <th>Wyjazd z Poznania</th> -->
			<th>Przyjaz&nbsp;do celu</th>
			<th>Wyjazd&nbsp;z celu</th>
			<!-- <th>Przyjazd do Poznania</th> -->
			<th>Powrót do Polski</th>

			<!-- <th>Potwierdzony wyjazd</th> -->
			<!-- <th>Opcje wyjazd</th> -->

			<!--Stara opcja wyświetlania jak uzytkownicy zagłosują to wybpierdole przegranego-->

			<!-- <th>Potwierdzony wyjazd</th>
			<th>Opcje wyjazd</th>
			<th>Wolne wyjazd</th>

			<th>Potwierdzone powrót</th>
			<th>Opcje powrót</th>
			<th>Wolne powrót</th> -->

			<!--Nowa opcja wyświetlania -->
			<th>
				<span
					data-toggle="tooltip"
					title="Uczestnicy potw(rezerwacje potw)/uczestnicy OP/(rezerwacje OP)/ Wolne miejsca "
					>Wyjazd</span
				>
			</th>
			<th>Powrót</th>

			<!-- <th>Ilość os. anulowanych</th> -->
			<!-- <th>Kwota kontrolna</th> -->
			<th>Status</th>
			<th>Piloci</th>
			<!-- <th>Zakończenie sprzedaży</th> -->
			<th>Data do potwierdzenia</th>
			<th>&nbsp;</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of showElements" [ngClass]="row.class">
			<td *ngIf="showCheckboxes">
				<input type="checkbox" name="setToMapObjects_{{ row.id }}" [(ngModel)]="row.checked" />
			</td>
			<td>{{ row.name }}</td>
			<td>
				{{ row.departureFromFirstStop }}<br />
				<small>{{ row.departureFromFirstStopWeekday }}</small>
			</td>
			<!-- <td>{{ row.departureFromPoznan }}</td> -->

			<td>
				{{ row.accommodationFrom }}<br />
				<small>{{ row.accommodationFromDestinationWeekday }}</small>
			</td>
			<td>
				{{ row.accommodationTo }}<br />
				<small>{{ row.accommodationToWeekday }}</small>
			</td>
			<!-- <td>{{ row.arrivalToPoznan }}</td> -->
			<td>
				{{ row.arrivalToLastStop }}<br />
				<small>{{ row.arrivalToLastStopWeekday }}</small>
			</td>

			<!--Stara opcja wyświetlania  -->

			<!-- <td>
				{{ row.departurePersonsOption }} /
				{{ row.departureReservationOption }}

			</td>
			<td>
				{{ row.departurePersonsOption }} /
				{{ row.departureReservationOption }}
			</td>
			<td [ngClass]="{ error: row.returnsTransportFreePlaces < 0 }">
				{{ row.departureTransportFreePlaces }}
			</td>
			<td>
				{{ row.returnsPersonsConfirm }} /
				{{ row.returnsReservationsConfirm }}
			</td>
			<td>
				{{ row.returnsPersonsOptions }} /
				{{ row.returnsReservationsOptions }}
			</td>
			<td [ngClass]="{ error: row.returnsTransportFreePlaces < 0 }">
				{{ row.returnsTransportFreePlaces }}
			</td> -->

			<!--Nowa opcja wyświetlania -->

			<td [ngClass]="{ error: row.departureTransportFreePlaces < 0 }">
				{{ row.departuresPersonsConfirm }}
				({{ row.departuresReservationConfirm }}) /
				{{ row.departurePersonsOption }}
				({{ row.departureReservationOption }}) /
				{{ row.departureTransportFreePlaces }}
			</td>
			<td [ngClass]="{ error: row.returnsTransportFreePlaces < 0 }">
				{{ row.returnsPersonsConfirm }}
				({{ row.returnsReservationsConfirm }}) /
				{{ row.returnsPersonsOptions }}
				({{ row.returnsReservationsOptions }}) /
				{{ row.returnsTransportFreePlaces }}
			</td>

			<!-- <td>{{ row.departuresCancels }}</td> -->
			<!-- <td>{{ row.controlAmount }}</td> -->
			<td>{{ row.status }}%</td>
			<td>{{ row.touristGuide }}</td>
			<!-- <td>{{ row.saleClosingDate }}</td> -->
			<td>{{ row.confirmDeadline }}</td>
			<td class="text-end align-middle">
				<button class="btn btn-primary" (click)="settingsOpen(row)">
					<i class="fas fa-angle-double-right fa-lg"></i>
				</button>
			</td>
		</tr>
	</tbody>
</table>
